export default __webpack_public_path__ + "static/media/IMAGE.f82d8def.jpg";